import React, { useState, useRef } from "react";
import "./contentpage.css";
import Question from "../components/Question";
import LandingSection from "./LandingSection";
import FloatingPageNav from "../components/FloatingPageNav";

function BitcoinTechPage82() {
  const contentRef = useRef(null);
  const titleText = "Segwit";
  const links = {
    prev: "/bitcoin-tech-page-81",
    index: "/index-bitcoin-tech",
    next: "/bitcoin-tech-page-83",
  };
  
const questions = [
  {
    text: "1. What was the primary cause of transaction ID (txid) malleability in legacy Bitcoin transactions?",
    options: [
      { value: "A", label: "A. Variable block size limits" },
      { value: "B", label: "B. Inclusion of scriptSig in the txid hash" },
      { value: "C", label: "C. Use of Proof of Work mining" },
      { value: "D", label: "D. Absence of Merkle trees" },
    ],
    correct: "B",
  },
  {
    text: "2. Which part of a Bitcoin transaction was most commonly manipulated to induce txid malleability?",
    options: [
      { value: "A", label: "A. scriptPubKey" },
      { value: "B", label: "B. locktime" },
      { value: "C", label: "C. scriptSig" },
      { value: "D", label: "D. output value" },
    ],
    correct: "C",
  },
  {
    text: "3. How does Segregated Witness (SegWit) eliminate transaction ID malleability?",
    options: [
      { value: "A", label: "A. By encrypting signatures" },
      { value: "B", label: "B. By enforcing larger blocks" },
      { value: "C", label: "C. By excluding witness data from the txid hash" },
      { value: "D", label: "D. By removing scripts entirely" },
    ],
    correct: "C",
  },
  {
    text: "4. What new metric did SegWit introduce to calculate transaction size and fees?",
    options: [
      { value: "A", label: "A. Byte size" },
      { value: "B", label: "B. Gas units" },
      { value: "C", label: "C. Transaction weight" },
      { value: "D", label: "D. Mining difficulty" },
    ],
    correct: "C",
  },
];

  // State to track selected answers for all questions
  const [answers, setAnswers] = useState({});

  // Function to update an answer
  const handleAnswerChange = (questionIndex, selectedValue) => {
    setAnswers((prev) => ({ ...prev, [questionIndex]: selectedValue }));
  };

  // Compute score
  const score = questions.reduce((total, q, index) => {
    return total + (answers[index] === q.correct ? 1 : 0);
  }, 0);
  
  const legacy_tx = `{
  "txid": "d46a...1b",
  "version": 1,
  "locktime": 0,

  "vin": [
    {
      "txid": "4d3c...ae",
      "vout": 0,
      "scriptSig": {
        "asm": "3045022100...01 0287ab...", 
        "hex": "4830...01210287ab..."
      },
      "sequence": 4294967295
    }
  ],
  "vout": [
    {
      "value": 0.01500000,
      "n": 0,
      "scriptPubKey": {
        "asm": "OP_DUP OP_HASH160 1b2e...b5 OP_EQUALVERIFY OP_CHECKSIG",
        "hex": "76a9...88ac",
        "type": "pubkeyhash",
        "address": "1A1zP1..."
      }
    }
  ]
}
`;
  const segwit_tx = `{
  "txid": "a63e...2f",
  "hash": "b84e...9c", 
  "version": 2,
  "locktime": 0,
  "vin": [
    {
      "txid": "98a2...dc",
      "vout": 1,
      "scriptSig": {
        "asm": "",
        "hex": ""
      },
      "sequence": 4294967295
    }
  ],
  "vout": [
    {
      "value": 0.01500000,
      "n": 0,
      "scriptPubKey": {
        "asm": "0 14 1b2e...b5",
        "hex": "0014...b5",
        "type": "witness_v0_keyhash",
        "address": "bc1qxy2kg..."
      }
    }
  ],
  "witness": [
    [
      "30440220...01",
      "0287ab..."
    ]
  ]
}
`;
  const coinbase_witness = `OP_RETURN 0x24aa21a9ed...  // commitment to the witness Merkle root`;
  const segwit_structure = `[version] [marker=0x00] [flag=0x01] [inputs] [outputs] [witness] [locktime]`;
  const segwit_code = `uint256 CTransaction::GetHash() const {
    return SerializeHash(*this, SER_GETHASH, 0);
}

uint256 CTransaction::GetWitnessHash() const {
    if (wit.IsNull()) return GetHash();
    return SerializeHash(*this, SER_GETHASH, 0);}`;
  const DER_sig = `30 45 02 20 <r> 02 21 <s> 01`;
  const nonDER_sig = `30 45 02 20 00<r> 02 21 <s> 01`;
  const scriptsig = `<signature> <pubkey>`;
  const encoded_scriptsig = `0x48 <DER-encoded signature> 0x41 <pubkey>`;
  const malleated_scriptsig = `OP_PUSHDATA1 0x48 <DER-encoded signature> OP_PUSHDATA1 0x41 <pubkey>`;
  const trailing_junk = `<signature> <pubkey> 0x01`;
  const OP_0 = `OP_0`;
  const OP_FALSE = `OP_FALSE`;
  const OP_NOP = `<signature> <pubkey> OP_NOP`;
  const segwit_calc = `
3*(non-segwit-part-of-transaction) + 1*(segwit-part-of-transaction)`;
  const P2PKH = `1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa`;
  const P2SH = `3J98t1WpEZ73CNmQviecrnyiWrnqRhW6d6Q`;
  const P2SH_P2WPKH = `3QJmVt5Xh5osjja3vM6p2PTcdyZ8Qfq1sU`;
  const Bech32 = `bc1qar0srrr5wqr8vqxqghztzzjw4ewc29w`;
  return (
    <div className="container" ref={contentRef}>
    
      
     
       <LandingSection
        titleText={titleText}
        scrollToRef={contentRef}
        progressValue={82}
        timerMinutes={60}
        currentLevel={6}
        unlockedBadges={11}
      />
      
      <p className="content">Welcome to Day 82!
Today’s lesson takes you deep into one of the most important upgrades in Bitcoin’s history: Segregated Witness (SegWit). To truly understand why SegWit was necessary, we begin by examining how legacy Bitcoin transactions were structured and how this design unintentionally introduced the problem of transaction ID (txid) malleability. From there, the lesson explores how SegWit fundamentally restructured transactions to separate signatures from core transaction data, solving malleability while unlocking improvements in scalability, fee efficiency, and future protocol upgrades.<br/>
        Segregated Witness or SegWit is one of the most important upgrades in
        Bitcoin’s protocol history. To understand SegWit, it is crucial to first
        grasp how Bitcoin transactions were originally structured, why that
        structure led to serious problems such as transaction ID malleability,
        and how SegWit fundamentally changed the transaction format to solve
        these issues while simultaneously unlocking improvements like increased
        scalability and support for future upgrades.
        <br />
        <br />
        <b>The Legacy Bitcoin Transaction Structure</b>
        <br />
        <br />
        Bitcoin transactions are made up of inputs and outputs. Each input
        references a previous output and includes a script, called scriptSig,
        that satisfies the spending conditions of the referenced output. Each
        output specifies an amount of bitcoin and a locking script,
        scriptPubKey, that sets the conditions for spending it.
        <br />A basic transaction consists of fields such as version, list of
        inputs, list of outputs, and locktime. Each input includes a previous
        transaction hash (txid), the output index, scriptSig, and a sequence
        number. Each output consists of the amount and scriptPubKey.
        <br />
        What’s important is that the entire transaction is serialized in a
        specific format and hashed to produce the transaction ID, also known as
        txid. The problem lies in the fact that the scriptSig is included in
        this serialization. That means if you change even a single byte of
        scriptSig, the txid changes, even though the effect of the transaction
        remains the same on the blockchain.
        <br />
        This behavior opened the door to a class of attacks called transaction
        malleability, which had far-reaching consequences for systems that
        relied on predictable txids, such as multi-party protocols, payment
        channels, or off-chain protocols like the Lightning Network.
        <br />
        <br />
        Structure of a Legacy BItcoin Transaction is shown below in JSON format.
      </p>
      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{legacy_tx}</pre>
      </div>
      <p className="content">
        <ul>
          <li>Signatures go into scriptSig inside the vin.</li>
          <li>The txid is calculated including the scriptSig.</li>
        </ul>
        
    
      
        <b>Transaction ID Malleability </b>
        <br />
        <br />
        Transaction ID malleability refers to a class of issues in Bitcoin where
        a transaction's txid i.e the unique identifier derived from a double
        SHA256 hash of the serialized transaction can be changed without
        altering the actual behavior or effect of the transaction. This happens
        because certain parts of the transaction, specifically the scriptSig
        (the unlocking script), are included in the txid calculation even though
        they are not relevant for consensus once the transaction is validated.
        Since there is flexibility in how the scriptSig can be constructed,
        malicious or accidental changes to it can cause the same transaction to
        be hashed differently, resulting in a different txid.
        <br />
        This vulnerability caused significant reliability issues in higher-layer
        Bitcoin applications. Payment channels, for example, rely on chaining
        unconfirmed transactions together by referencing the txid of previous
        ones. If a counterparty malleated a transaction by altering the
        scriptSig before it was confirmed on-chain, the txid would change. As a
        result, all dependent transactions referencing the original txid would
        become invalid and unbroadcastable. Similarly, wallet software that
        tracked unconfirmed transactions using txids would sometimes lose track
        of funds if a malleated version of a transaction made it into a block
        instead of the original.
        <br />
        The most common method of inducing txid malleability involved altering
        how data was pushed onto the stack within the scriptSig. Bitcoin script
        allows various ways to encode data pushes. <br />
        <br />
        Let us understand some avenues of inducing txid malleability in Bitcoin
        Transaction
        <br />
        <br />
        <b>1. Use of Different Push Opcodes in scriptSig</b>
        <br />
        <br />
        Pushing a 71-byte DER signature could be done using a single-byte push
        opcode like 0x48, or using OP_PUSHDATA1 followed by 0x48. Both methods
        result in the same script evaluation but produce a different serialized
        byte stream, and hence a different txid.
        <br />
        <br />
        Original scriptSig :
      </p>
      <div className="code-block">
        <pre>{scriptsig}</pre>
      </div>
      <p className="content">Encoded as :</p>
      <div className="code-block">
        <pre>{encoded_scriptsig}</pre>
      </div>
      <p className="content">Malleated version :</p>
      <div className="code-block">
        <pre>{malleated_scriptsig}</pre>
      </div>
      <p className="content">
        <b>2. Trailing Junk in scriptSig</b>
        <br />
        <br />
        Another technique used to exploit txid malleability was inserting
        trailing junk into the scriptSig after the necessary data for script
        validation. If a script contains a valid signature and public key, the
        transaction is valid even if additional unused data follows. <br />
        For instance, a scriptSig like sig pubkey 0x01 would still be accepted,
        but it would cause the txid to differ from one without the extra 0x01.
        <br />
      </p>
      <div className="code-block">
        <pre>{trailing_junk}</pre>
      </div>
      <p className="content">
        The 0x01 at the end doesn’t affect the script but causes txid change.
        <br />
        <br />
        <b>3. Non-DER-encoded Signatures</b>
        <br />
        <br />
        Before BIP 66 was activated in 2015, Bitcoin accepted signatures that
        were not strictly DER-encoded. This opened up more room for
        malleability. <br />
        For example, the same numeric values in a signature could be encoded
        with or without leading zeros or slightly varied lengths, all of which
        were valid under the old rules. A signature of the form 30 45 02 20
        &lt;r&gt; 02 21 &lt;s&gt; 01 could be subtly changed to 30 46 02 21
        00&lt;r&gt; 02 21 &lt;s&gt; 01, which was semantically equivalent but
        had a different binary representation and hence a different txid.
        <br />
      </p>
      <div className="code-block">
        <pre>{DER_sig}</pre>
      </div>
      <div className="code-block">
        <pre>{nonDER_sig}</pre>
      </div>
      <p className="content">
        <b>4. Use of OP_0 instead of OP_FALSE</b>
        <br />
        <br />
        Even simple script changes like replacing OP_0 with OP_FALSE could
        affect the txid. Both opcodes push a zero onto the stack, and they
        behave identically in script execution, but they are different bytes in
        the serialized transaction. Similarly, using OP_NOP—which performs no
        operation and is ignored—can be inserted into scripts without affecting
        execution but will still change the txid.
        <br />
      </p>
      <div className="code-block">
        <pre>{OP_0}</pre>
      </div>
      <div className="code-block">
        <pre>{OP_FALSE}</pre>
      </div>
      <p className="content">
        Both push a 0, but their opcodes are different (0x00 vs 0x00 — same in
        this case, but when combined with other stack items, the effect is
        notable in scriptSig serialization).
        <br />
        <br />
        <b>5. Use of OP_NOPs</b>
        <br />
        <br />
        Adding OP_NOP in places where they are ignored does not affect script
        validity but changes txid.
      </p>
      <div className="code-block">
        <pre>{OP_NOP}</pre>
      </div>
      <p className="content">
        This is ignored during evaluation but changes serialization. <br />
        <br />
        <br />
        <b>6. Signature with Different s Values (Low-s vs. High-s)</b>
        <br />
        <br />
        ECDSA has two valid values for s: if s is valid, then so is n - s (where
        n is the order of the curve). Both are valid signatures, but they hash
        differently.
        <br />
        This was addressed by enforcing low-s values via BIP 62 and later
        consensus rules.
        <br />
        <br />
        BIP 62 attempted to outline a comprehensive set of rules to eliminate
        malleability vectors by enforcing stricter encoding rules on signatures,
        data pushes, and script numbers. For instance, it required that all
        pushes use the minimal possible opcode, that script numbers use minimal
        encoding, and that scripts be free of extraneous data. While BIP 62 was
        never fully activated as a formal consensus rule, many of its
        recommendations were implemented over time as part of Bitcoin's
        standardness policy or through later soft forks like BIP 66 and BIP 141.
        <br />A more complete and permanent solution to txid malleability was
        provided by Segregated Witness, or SegWit, introduced through BIP 141 in
        2017. SegWit reorganized transaction structure so that witness data,
        including signatures, was separated from the part of the transaction
        that is used to compute the txid. The txid of a segwit transaction
        excludes all scriptSig and witness data, meaning changes in the
        signature or its encoding do not affect the txid. This solved the
        malleability problem entirely for SegWit transactions and enabled more
        advanced protocols like Lightning Network to become reliable and
        production-ready.
        <br />
        Overall, transaction ID malleability was a subtle yet highly disruptive
        vulnerability in Bitcoin’s early design. It was exploited both
        intentionally and unintentionally and caused significant operational
        headaches for developers and businesses. Through a combination of soft
        forks and structural upgrades like SegWit, Bitcoin has largely
        eliminated malleability as an issue, at least for modern transaction
        types. However, understanding these historical malleability vectors
        remains essential for interpreting legacy behavior, auditing transaction
        histories, and designing interoperable systems.
        <br />
        <br />
        <b>BIP 62 and Its Limitations</b>
        <br />
        <br />
        In response to these problems, BIP 62 proposed a series of rules to
        eliminate the sources of malleability. It outlined a strict set of
        canonical forms that scripts and signatures should adhere to. These
        included
      <ul>
        <li>Enforcing strict DER encoding for signatures</li>
        <li>Prohibiting non-minimal push operations</li>
        <li>Forbidding superfluous operations that had no effect on execution</li>
        <li>Requiring certain numeric encodings to be in a canonical form</li>
      </ul>
       
        The idea was to make all valid transactions have a unique encoding so
        that malleability through syntactic variation would be impossible.
        <br />
        <br />
        However, BIP 62 faced deployment challenges. It was difficult to enforce
        some of its rules without risking breaking backward compatibility.
        Moreover, it only addressed known sources of malleability, leaving the
        door open for future or unknown ones to emerge.
        <br />
        <br />
        Ultimately, BIP 62 was never fully activated. While parts of it were
        implemented piecemeal (e.g., strict DER signatures via BIP 66), the
        Bitcoin community realized that a more comprehensive solution was
        needed.
        <br />
        <br />
        <b>The Introduction of SegWit: BIP 141</b>
        <br />
        <br />
        Segregated Witness, introduced in BIP 141, took a fundamentally
        different approach. Instead of trying to canonically enforce the
        encoding of existing transactions, it restructured transactions so that
        signatures (witness data) were no longer part of the portion that was
        hashed to compute the txid.
        <br />
        This was accomplished by introducing a new structure called the witness,
        which is placed outside of the traditional transaction format. A SegWit
        transaction separates the signature and other unlocking data into this
        witness field. When computing the transaction ID, the witness is
        excluded from the hash.
        <br />
        This change has the effect of making the transaction ID immutable
        regardless of how the witness data is encoded, completely solving
        transaction ID malleability for SegWit transactions.
      </p>
      <div className="code-block">
        <pre>{segwit_structure}</pre>
      </div>
      <p className="content">
        The marker and flag are used to indicate the presence of witness data.
        Older nodes that don’t understand SegWit will see a transaction that
        looks like it only includes the version, inputs, outputs, and locktime,
        and will ignore the witness field. This property allows SegWit to be a
        soft fork.
      </p>
      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{segwit_tx}</pre>
      </div>
      <p className="content">
        <ul>
          <li>Signature and pubkey moved into the witness field.</li>
          <li>The txid excludes the witness, making it immutable.</li>
         
        </ul>
        
        <b>Activation via BIP 9 and the SegWit Saga</b>
        <br />
        <br />
        SegWit’s activation was proposed as a soft fork under BIP 141, using the
        version bits signaling mechanism described in BIP 9. This required
        miners to signal readiness by setting a specific bit in the block
        version field.
        <br />
        However, what followed was a drawn-out political and economic standoff.
        Some major mining pools and businesses opposed SegWit for various
        reasons, including claims about its complexity, opposition to the block
        size tradeoff, and political struggles over control of Bitcoin’s future
        roadmap.
        <br />
        Despite broad support from users and developers, SegWit activation
        stalled due to lack of sufficient miner signaling. This led to the
        emergence of the User Activated Soft Fork (UASF) movement, which was
        formalized under BIP 148.
        <br />
        UASF was a mechanism by which full nodes would begin rejecting
        non-SegWit blocks after a certain date (August 1, 2017). The idea was to
        force the hand of miners by creating a network split if they failed to
        comply. Eventually, this pressure worked, and SegWit was locked in and
        activated.
        <br />
        <br />
        <b>Witness Commitments in the Coinbase Transaction</b>
        <br />
        <br />
        One technical challenge in SegWit was that witness data is not part of
        the traditional Merkle tree used in block headers. Therefore, a
        mechanism was needed to ensure witness data could not be tampered with
        by miners.
        <br />
        The solution was the introduction of the witness commitment. This is a
        special data field included in the coinbase transaction’s output,
        encoded as an OP_RETURN script, which commits to the Merkle root of all
        witness data.
        <br />
        <br />
        Here’s what it looks like in code:
      </p>
      <div className="code-block">
        <pre>{coinbase_witness}</pre>
      </div>
      <p className="content">
        This ensures that full nodes validating the block can verify that the
        witness data included matches the commitment in the coinbase, preserving
        the integrity of the witness data.
        <br />
        <br />
        <b>Code-Level View of SegWit Transactions</b>
        <br />
        <br />
        From a code perspective, SegWit introduces several changes in how
        transactions are validated and serialized. In Bitcoin Core, you’ll see
        that functions like GetTxid() use only the non-witness serialization of
        the transaction.
      </p>
      <div className="code-block" style={{ textAlign: "left" }}>
        <pre>{segwit_code}</pre>
      </div>
      <p className="content">
        When you look at the validation logic, SegWit scripts are enforced in a
        separate phase. The scriptPubKey for SegWit outputs is simple (e.g.,
        OP_0 &lt;20-byte-hash&gt;), and the full validation logic is deferred
        until the witness data is evaluated.
        <br />
        This modularization allows for clean support of new witness versions in
        the future. SegWit v0 is the current standard, but the system is
        designed to support future witness versions with new rules.
        <br />
        <br />
        <b>Impact of SegWit on Transaction Size and Fee Calculation</b>
        <br />
        <br />
        SegWit introduced a fundamental change in how Bitcoin transaction size
        is calculated by decoupling the witness data such as signatures and
        public keys, from the main transaction data. Before SegWit, all
        transaction components, including the unlocking scripts (scriptSig),
        were included in the serialized transaction when calculating its size,
        directly affecting both the block size and the transaction fee. With
        SegWit, the witness data is placed in a separate structure that is not
        included when computing the transaction ID (txid) and is discounted when
        calculating the transaction’s weight. Instead of using raw byte size,
        SegWit introduced a new metric called transaction weight, which is
        calculated as:{" "}
      </p>
      <div className="code-block">
        {segwit_calc}
        <pre></pre>
      </div>
      <p className="content">
        This effectively gives witness data a 75% discount when computing
        weight, meaning SegWit transactions occupy less space in terms of block
        weight, allowing more transactions per block. This change helps optimize
        block space usage and reduces transaction fees for users adopting
        SegWit, while still preserving compatibility with legacy systems. The
        introduction of block weight, capped at 4 million weight units (WU),
        replaced the old 1MB block size limit and enabled Bitcoin to scale more
        efficiently without increasing the maximum block size directly.
        <br />
        <br /> <b>Legacy vs SegWit Nodes</b>
        <br />
        <br />
        When running a SegWit-enabled node, you receive SegWit blocks that may
        exceed 1MB in size due to the inclusion of witness data. However, if you
        operate a legacy (non-SegWit) node, all witness data from SegWit
        transactions is stripped, resulting in a trimmed version of the block
        that remains under 1MB. SegWit was implemented as a soft fork, meaning
        that even legacy nodes remain valid and stay up to date with the
        blockchain. The tradeoff, however, is that legacy nodes cannot verify
        the validity of SegWit transactions since they do not see the witness
        data. <br />
        For non-mining nodes, SegWit offered a significant benefit i.e more
        transactions could now fit into a block due to the separation of witness
        data. <br />
        Despite these technical improvements, SegWit was not universally
        welcomed. Some in the community were uncomfortable with the idea of
        storing and propagating transactions without the full set of signatures,
        leading to concerns about verification transparency. This dissent
        culminated in a chain split and the creation of Bitcoin Cash (BCH),
        which rejected SegWit and opted instead for a different scaling approach
        through adjustable block sizes. <br />
        On the address format side, legacy formats like P2PKH and P2SH stand for
        "Pay to Public Key Hash" and "Pay to Script Hash," respectively. SegWit
        introduced its own formats such as P2WPKH and P2WSH, which stand for
        "Pay to Witness Public Key Hash" and "Pay to Witness Script Hash."
        <br />
        <br /> <b>Legacy vs Segwit Adresses</b>
        <br />
        <br />
        These addresses typically start with the number "3" and are known as
        Pay-to-Script-Hash (P2SH) addresses.
        <br />
        The introduction of SegWit addresses has paved the way for further
        innovations, such as Native SegWit addresses, which offer even greater
        efficiency and lower fees by utilizing the Bech32 address format. While
        Native SegWit addresses provide these advantages, they may face
        compatibility issues with some wallets and services that have not yet
        adopted the newer format. Legacy addresses, on the other hand, are still
        widely used and are typically represented as P2PKH (Pay-to-PubKey-Hash)
        or P2SH (Pay-to-Script-Hash) addresses, and they start with "1" or "3,"
        respectively.
        <br />
        <br />
        Here are some examples of legacy and SegWit addresses{" "}
      </p>
      <p className="content">Legacy Address (P2PKH): </p>
      <div className="code-block">
        <pre>{P2PKH}</pre>
      </div>
      <p className="content">Legacy Address (P2SH): </p>
      <div className="code-block">
        <pre>{P2SH}</pre>
      </div>
      <p className="content">Legacy Address (P2SH-P2WPKH): </p>
      <div className="code-block">
        <pre>{P2SH_P2WPKH}</pre>
      </div>
      <p className="content">Legacy Address (Bech32, P2WPKH): </p>
      <div className="code-block">
        <pre>{Bech32}</pre>
      </div>
      <p className="content">
        Segregated Witness was a foundational upgrade to the Bitcoin protocol.
        It elegantly solved a longstanding problem (malleability), improved
        scalability, and laid the groundwork for future innovations. Despite the
        controversy and delay in its activation, SegWit’s successful deployment
        demonstrated the strength and resilience of Bitcoin's decentralized
        governance model. It remains a pivotal milestone in Bitcoin’s evolution,
        one that continues to support modern use cases like Lightning, Taproot,
        and beyond.<br/><br/>
        <b>Summary of Today's Lesson</b>
        <br/><br/>In this lesson, you learned how legacy Bitcoin transactions included signatures in the txid calculation, making them vulnerable to transaction malleability through multiple syntactic variations in scriptSig. You explored the real-world consequences of this flaw, particularly for higher-layer protocols and unconfirmed transaction chains. The lesson then walked through early mitigation attempts such as BIP 62 and why they fell short, before introducing SegWit via BIP 141 as a complete and elegant solution. By separating witness data from the txid, SegWit eliminated malleability, introduced block weight and discounted witness data, enabled more efficient fee calculation, and preserved backward compatibility through a soft fork. Finally, you examined SegWit’s activation journey, witness commitments, code-level changes, and its lasting impact on Bitcoin’s scalability and future innovations like Lightning and Taproot.
      </p>
      <h2>Test your understanding</h2>
      {questions.map((q, index) => (
        <Question
          key={index}
          questionText={q.text}
          options={q.options}
          correctAnswer={q.correct}
          onAnswer={(value) => handleAnswerChange(index, value)}
        />
      ))}

      <div style={{ marginTop: "20px", fontWeight: "bold", fontSize: "1.2em" }}>
        Score: {score} / {questions.length}
      </div>

      <FloatingPageNav
        prevLink={links.prev}
        indexLink={links.index}
        nextLink={links.next}
      />

    </div>
  );
}

export default BitcoinTechPage82;
